<template>
  <div v-if="emailData" class="preview" :style="{backgroundColor: emailData.root.data.backdropColor}" :class="{ noEvents: currentView === 'Preview' ||  currentView === 'FS',  phoneView: viewport === 'phone'}" >
    <div 
      :style="{
        backgroundColor: emailData.root.data.backdropColor,
        color: emailData.root.data.textColor,
        fontSize: emailData.root.data.fontSize,
        fontFamily: fontFamily(emailData.root.data.fontFamily),
        padding: '32px 0',
        width: '100%',
        minHeight: '100%',
        
      }"
    >
      <table
        align="center"
        width="100%"
        :style="{ maxWidth: '600px', margin: '0 auto', backgroundColor: emailData?.root?.data?.canvasColor, position: 'relative', wordWrap: 'break-word' }"
        role="presentation"
        cellspacing="0"
        cellpadding="0"
        border="0"
      >
        <tbody>
          <tr style="width: 100%">
            <td>
              <div v-if="emailData.root.data.childrenIds.length === 0 && currentView === 'Edit'">
                <EmptyBlock 
                :parentId="'root'" :parentType="'root'"
                @showAddList="showAddList($event, 'root')" />
              </div>
              <div v-for="id in emailData.root.data.childrenIds" :key="id" 
                @mousemove="checkProximity($event, id)"
                @mouseleave="resetProximity"
                class="component-container"
                :class="{component: !getPositionType(emailData[id])}">
                <component
                  @click="shareProps(id, emailData[id]); resetAddState(); isElementActive = true, activeComponentId = id"
                  :is="getComponentType(emailData[id]?.type)"
                  :data="emailData[id]?.data"
                  :blockId="id"
                  :emailData="emailData"
                ></component>
                <div v-if="isNearTopButton" class="add-button add-button-top" :style="{left: leftDistance(emailData[id])}" @click.stop.self="showAddList($event, 'top', id)">+</div>
                <div v-if="isNearBottomButton" class="add-button add-button-bottom" :style="{left: leftDistance(emailData[id])}" @click.stop.self="showAddList($event, 'bottom', id)">+</div>
                <div v-if="isElementActive && emailData[id]?.data?.style?.position !== 'absolute' && activeComponentId == id"
                  class="delete-button" @click.stop="deleteBlock(id)">
                  <span class="material-symbols-outlined">delete</span> 
                </div>
                <div v-if="isElementActive && emailData[id]?.data?.style?.position !== 'absolute' && activeComponentId == id" class="move-buttons">
                  <div class="move-button move-up" @click.stop="moveBlock(id, 'up')">
                    <span class="material-symbols-outlined">arrow_upward</span>
                  </div>
                  <div class="move-button move-down" @click.stop="moveBlock(id, 'down')">
                    <span class="material-symbols-outlined">arrow_downward</span>
                  </div>
                </div>
                <div  v-if="isElementActive && emailData[id]?.data?.style?.position == 'absolute' && activeComponentId == id"
                  class="move-buttonsAbsolute"
                  tabindex="0"
                  :style="{left: `${emailData[id].data.style.direction.left}px`, top: `${emailData[id].data.style.direction.top}px`}"
                >
                  <div class="delete-button deleteAbsolute" @click.stop="deleteBlock(id)">
                    <span class="material-symbols-outlined">delete</span> 
                  </div>
                  <div class="move-button moveAbsolute moveAbsolute-up" @click.stop= "moveBlockAbsolute(id , 'up')">
                    <span class="material-symbols-outlined">arrow_upward</span>
                  </div>
                  <div class="move-button moveAbsolute moveAbsolute-down" @click.stop="moveBlockAbsolute(id, 'down')">
                    <span class="material-symbols-outlined">arrow_downward</span>
                  </div>
                  <div class="move-button moveAbsolute moveAbsolute-left" @click.stop="moveBlockAbsolute(id, 'left')">
                    <span class="material-symbols-outlined">keyboard_backspace</span>
                  </div>
                  <div class="move-button moveAbsolute moveAbsolute-right" @click.stop="moveBlockAbsolute(id, 'right')">
                    <span class="material-symbols-outlined">arrow_right_alt</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <AddList v-if="showAddListPopup" :style="addListStyle" @close="showAddListPopup = false" @add-blockC="addBlockComponent"
       :position="addPosition" :parentId="activeComponentId" :parentRoot="true" :parentType="'root'"
       :clicked="clicked" :blockId="'root'"/>
    </div>
  </div>
  <div v-else>Loading...</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import HeadingBlock from './blocks/HeadingBlock.vue';
import HtmlBlock from './blocks/HtmlBlock.vue';
import TextBlock from './blocks/TextBlock.vue';
import SpacerBlock from './blocks/SpacerBlock.vue';
import ColumnsContainerBlock from './blocks/ColumnsContainerBlock.vue';
import ImageBlock from './blocks/ImageBlock.vue';
import ButtonBlock from './blocks/ButtonBlock.vue';
import DividerBlock from './blocks/DividerBlock.vue';
import ContainerBlock from './blocks/ContainerBlock.vue';
import RulesetBlock from './blocks/RulesetBlock.vue';
import QrBlock from './blocks/QrBlock.vue';
import EmptyBlock from './blocks/EmptyBlock.vue';
import AddList from './Reusables/AddList.vue';
import debounce from 'lodash/debounce';
import DynamicBlock from './blocks/DynamicBlock.vue';
import DynContainerBlock from './blocks/DynContainerBlock.vue';


export default {
  props: ['emailData'],
  name: 'Preview',
  components: {
    AddList,
    EmptyBlock,
  },
  computed: {
    //...mapState (['emailData']),
    ...mapGetters(['getEmailData', 'getView', 'getViewport']),
    /* emailData() {
      return this.getEmailData;
    }, */
    currentView() {
      return this.getView;
    },
    viewport() {
      return this.getViewport;
    }
},
  data() {
    return {
      activeComponentId: null, //stores Id of Component, where the AddList was triggered from
      showAddListPopup: false,
      addListStyle: {},
      addPosition: 'bottom', //default position to insert new relative to activeComponentId
      clicked: "component", //type of the clicked component
      isElementActive: false,
      isNearTopButton: false,
      isNearBottomButton: false,
      saveToStorageDebounced: debounce(function() {
      this.saveToLocalStorage();
    }, 20000) // Speichert nach 20 Sekunden Inaktivität
    };
  },
  methods: {
    ...mapActions(['updateSharedData', 'resetAddState', 'addNewBlock', 'removeBlock', 'moveBlockInStore', 'changePositionStyle']),
    getComponentType(type) {
      const components = {
        Heading: HeadingBlock,
        Text: TextBlock,
        Spacer: SpacerBlock,
        ColumnsContainer: ColumnsContainerBlock,
        Image: ImageBlock,
        Container: ContainerBlock,
        Button: ButtonBlock,
        Divider: DividerBlock,
        Html: HtmlBlock,
        Qr: QrBlock,
        Ruleset: RulesetBlock,
        DynContainer: DynContainerBlock,
        Dynamic: DynamicBlock
      };
      return components[type] || 'div';
    },
    shareProps(id, data) {
      this.updateSharedData({id, data});
    },
    getPositionType(data){
        return false;
    },
    showAddList(event, position, id) {
      event.stopPropagation();
      this.activeComponentId = id;
      this.addPosition = position;
      const rect = event.target.getBoundingClientRect();
      const isNearBottom = (rect.bottom + 250) >= (window.innerHeight + window.scrollY);
      if (isNearBottom) {
        this.addListStyle = {
          top: `${rect.top + window.scrollY - rect.height}px`,
          left: `${rect.left + window.scrollX}px`,
          transform: 'translateY(-240px)', // adjust as needed
        };
      } else {
        this.addListStyle = {
          top: `${rect.bottom + window.scrollY}px`,
          left: `${rect.left + window.scrollX}px`,
        };
      }
      this.showAddListPopup = true;
      document.addEventListener('click', this.handleOutsideClick);
    },
    handleOutsideClick(event) {
      if (this.showAddListPopup && !event.target.closest('.add-list-popup')) {
        this.showAddListPopup = false;
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    leftDistance(data){ //Überarbeiten
      /* if (data.data?.style.width && data.data?.style.width !== 'inherit' ){
        return `${0.5 * data.data?.style.width + data.data.style.padding.left}px`
      } else {
        return '50%'
      } */
     return '50%'
    },
    addBlockComponent(type, position) {
      this.addNewBlock({
        type: type,
        targetId: this.activeComponentId,
        position,
        parentId: 'root',
        parentType: 'root'
      });
      this.showAddListPopup = false;
    },
    deleteBlock(id) {
      console.log(id)
      this.removeBlock({ parentId: 'root', parentType: 'root', blockId: id });
    },
    moveBlock(id, direction) {
      this.moveBlockInStore({ id, direction });
    },
    moveBlockAbsolute(id, direction){
      this.changePositionStyle({id, direction})
    },
    checkProximity(event, id) {
      const rect = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const mouseX = event.clientX;

      // Check if the mouse is over any clickable elements within the container
      const elementUnderMouse = document.elementFromPoint(mouseX, mouseY);
      const isInteractiveElement = elementUnderMouse && ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(elementUnderMouse.tagName);

      if (!isInteractiveElement) {
        this.isNearTopButton = mouseY >= rect.top - 20 && mouseY <= rect.top + 20 && mouseX >= rect.left && mouseX <= rect.right;
        this.isNearBottomButton = mouseY >= rect.bottom - 20 && mouseY <= rect.bottom + 20 && mouseX >= rect.left && mouseX <= rect.right;
      } else {
        this.isNearTopButton = false;
        this.isNearBottomButton = false;
      }
    },
    resetProximity() {
      this.isNearTopButton = false;
      this.isNearBottomButton = false;
    },
    saveToLocalStorage() {
      const storedData = {
        emailData: this.emailData,
        savedAt: new Date().toLocaleString(),
      };
      localStorage.setItem('storedData', JSON.stringify(storedData));
      console.log('Email data saved to localStorage');
    },
    fontFamily(font){
      const fontFamilyMapping = {
        BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
        ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
        GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
        HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
        ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
        MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
        BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
        MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
        MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
        SIMPLE: 'Arial'
        }
        const fontFamily = fontFamilyMapping[font] || fontFamilyMapping.DEFAULT;
        return fontFamily
    
  }
  },
  mounted() {
    // Event Listener für Seiten-Reload oder Tab-Schließen
    window.addEventListener('beforeunload', this.saveToLocalStorage);
  },
  beforeUnmount() {
    // Entferne den Event Listener, wenn die Komponente zerstört wird
    window.removeEventListener('beforeunload', this.saveToLocalStorage);
  },
  watch: {
  emailData: {
    handler() {
      this.saveToStorageDebounced();
    },
    deep: true,
  },
}
};
</script>

<style scoped>
.phoneView {
  width: 500px;
  margin-left: auto;
  margin-right: auto;
}
.preview {
  min-height: 100%;
}

/* .component-container {
  position: relative; 
  min-width: fit-content
} Änderung  war notwenig, changelog: component/ compentActive replaced ComponentContainer*/

/* .component {
  border: 1px solid transparent;
  position: relative;
} */

.component {
  min-width: fit-content;
  position: relative;
}

.componentAbsolute{
  border: 1px solid transparent;
  opacity: 70%;
}


.component:hover {
  box-shadow: 0 0 0 2px var(--primary-color);
  z-index: 10;
  /* border: 1px solid var(--primary-color); */
}

.componentAbsolute:hover {
  border: 1px solid red;
}

.add-button {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background:var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}

.add-button-top {
  top: -10px;
  /* left: 50%;  */
  transform: translateX(-50%); 
}

.add-button-bottom {
  bottom: -10px;
  /* left: 50%;  */
  transform: translateX(-50%);
}

.component-container:hover .add-button {
  opacity: 1;
}

.delete-button {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 5px;
  position: absolute;
  top: -10px;
  left: -10px;
  background: white;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.deleteAbsolute{
  color: red;
}

.component-container:hover .delete-button {
  opacity: 1;
}

.add-list-popup {
  position: absolute;
  z-index: 2;
}

.noEvents {
  pointer-events: none;
}

.move-buttons {
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
}


.move-buttonsAbsolute {
  position: absolute;
  z-index: 5;
}


/*.moveAbsolute-buttons {
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
}

 .moveAbsolute-up{
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateY(-50%);
}

.moveAbsolute-down{
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateY(-50%);
}
.moveAbsolute-left{
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.moveAbsolute-right{
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
} */

.move-button {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
  border-radius: 50%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  padding: 5px;
}

.moveAbsolute {
  color: red;
  opacity: 1;
  z-index: 3
}

.component-container:hover .move-buttons .move-button {
  opacity: 1;
}


</style> 
